<app-modals [title]="title" [openModal]="openModal" [closeModal]="closeModal" [whenModalClose]="whenModalClose" [submitKey]="submitKey" [invalidFormGroup]="$safeNavigationMigration(entry?.invalid)" [isButtonsDisabled]="isButtonsDisabled" [onDismiss]="onDismiss" [isShaking]="$safeNavigationMigration(errors?.length) > 0">
  <form #entityForm="ngForm" [formGroup]="entry" (ngSubmit)="onSubmit(entry)" novalidate="novalidate">
    @if (errors?.length > 0) {
      <app-form-errors [errors]="errors"></app-form-errors>
    }

    <div class="row">
      <div class="col-12">
        <app-forms-form-group [value]="entry.get('name')" fieldName="name" [fieldLabel]="'MODALS.CARDS.NAME' | translate"><input class="form-control" id="name" type="text" autocomplete="name" formControlName="name" appAutoFocus="appAutoFocus" /></app-forms-form-group>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div><label for="card-element">{{ 'MODALS.CARDS.CARD_NUMBER' | translate }}</label><span class="form-control" id="card-element"></span></div>
      </div>
    </div>
  </form>
</app-modals>
